import React, { useEffect } from 'react'

import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { closeSnackbar, SnackbarProvider } from 'notistack'
import { Provider } from 'react-redux'
import { BrowserRouter, useNavigate } from 'react-router-dom'

import { setNavigate } from 'utils/navigation'

// Internal admin tool: no refetch on window refocus (avoids noise); still refetches on mount, key changes and invalidation.
const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
})

// Captures the router's navigate() into the module-level bridge so non-React code can navigate. Renders nothing.
const NavigationSetter = () => {
  const navigate = useNavigate()
  useEffect(() => setNavigate(navigate), [navigate])
  return null
}

type RootProps = {
  routes: React.ReactNode
  store: any
}

const Root = ({ store, routes }: RootProps) => (
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <SnackbarProvider
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        maxSnack={4}
        action={snackbarId => (
          <IconButton aria-label="Close" color="inherit" onClick={() => closeSnackbar(snackbarId)} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        )}>
        <BrowserRouter>
          <NavigationSetter />
          {routes}
        </BrowserRouter>
      </SnackbarProvider>
    </Provider>
  </QueryClientProvider>
)

export default Root
